var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from "moment";
import { buildNutritionRequestBody, getDefaultCustomizeOptions, getRecipeNutrition, } from "../../../../../Shared/components/CustomizeModal/CustomizeModal-utils";
import { clone } from "../../../../../Shared/utils/clone";
import { ActionTypes } from "../../../../OrderFlowProvider/OrderFlowActionTypes";
import { getMustReplaceIngredients } from "../../../../hooks/RecipeSelection/recipeSelectionUtils";
import { HandleCustomizeSubmit } from "../utils/RecipeModule-utils";
import { toggleRecipeSelection } from "./toggleRecipeSelection";
export const handleToggleRecipeSelection_V2 = ({ singleRecipeSelectLimit, enableAssignRecipes, enableAddMeals, cartMeals, recipes, program, deliveryDays, sku, companyUsesKlaviyo, dispatch, createKlaviyoEvent, logReactPixel, selectedDay, datadogLog, reactPixelKey, recipe, programMealId, setMeals, setAssignmentId, setQuantity, }) => __awaiter(void 0, void 0, void 0, function* () {
    const clonedCartMeals = clone(cartMeals);
    const { meals, currentRecipeAssignment, mealPrice, mealName, mealDate, currentAssignmentQuantity } = yield toggleRecipeSelection({
        singleRecipeSelectLimit,
        enableAssignRecipes,
        enableAddMeals,
        cartMeals: clonedCartMeals,
        program,
        deliveryDays,
        selectedDay,
        recipe,
        programMealId,
    });
    // Set the current assignment quantity and assignment id
    // for the customize modal.
    setQuantity(currentAssignmentQuantity);
    setAssignmentId(currentRecipeAssignment === null || currentRecipeAssignment === void 0 ? void 0 : currentRecipeAssignment.AssignmentId);
    const { ingredientsToReplace } = getMustReplaceIngredients(recipe);
    // If there are ingredients to replace and the current assignment quantity is greater than 0,
    // apply the default customizations to the recipe.
    if (ingredientsToReplace && ingredientsToReplace.length > 0 && currentAssignmentQuantity > 0) {
        const { options } = getDefaultCustomizeOptions(ingredientsToReplace, recipe, currentRecipeAssignment);
        const nutrition = yield getRecipeNutrition(recipe.RecipeId, buildNutritionRequestBody(options, recipe), datadogLog);
        // Default customizations need to be applied when the recipe quantity is incremented
        HandleCustomizeSubmit(recipes, selectedDay, dispatch)(recipe.RecipeId, programMealId, setMeals)(options, meals, undefined, currentRecipeAssignment, nutrition);
    }
    else {
        setMeals(meals);
        dispatch({ type: ActionTypes.SET_MEALS, payload: meals });
    }
    if (companyUsesKlaviyo) {
        let totalQuantity = 0;
        const mealsForKlaviyo = meals.filter((meal) => moment(meal.MealDate).isSame(moment(mealDate), "day") &&
            meal.ProgramMealId === programMealId &&
            meal.RecipeAssignments);
        mealsForKlaviyo.forEach((meal) => {
            var _a, _b, _c;
            totalQuantity +=
                (_c = (_b = (_a = meal === null || meal === void 0 ? void 0 : meal.RecipeAssignments) === null || _a === void 0 ? void 0 : _a.filter((ra) => ra.RecipeId === (recipe === null || recipe === void 0 ? void 0 : recipe.RecipeId))) === null || _b === void 0 ? void 0 : _b.reduce((accum, ra) => accum + ra.Quantity, 0)) !== null && _c !== void 0 ? _c : 0;
        });
        const eventInfo = {
            RecipeName: recipe.RecipeName,
            Quantity: totalQuantity,
            MealName: mealName,
            SKU: sku,
            DayOfWeek: moment(recipe.AvailableOn).format("ddd"),
        };
        createKlaviyoEvent("Added Recipe", eventInfo);
    }
    if (reactPixelKey) {
        const data = {
            content_name: recipe.RecipeName,
            content_ids: recipe.RecipeId,
            content_type: "meal",
            value: mealPrice,
            currency: "USD",
        };
        logReactPixel("AddMeal", data);
    }
});
